// src/hooks/useRouteTracking.ts
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { appInsights } from '../appinsights';

/**
 * Registra un PageView en Application Insights cada vez que cambia la ruta.
 *
 * Usar dentro de App (componente raíz dentro de BrowserRouter).
 * No retorna nada; su efecto es exclusivamente de telemetría.
 *
 * Se usa en lugar de enableAutoRouteTracking porque React Router v6
 * no expone un objeto history externo que pueda escuchar el ReactPlugin.
 */
const useRouteTracking = (): void => {
    const location = useLocation();

    useEffect(() => {
        if (!appInsights) return;
        appInsights.trackPageView({ uri: location.pathname });
    }, [location.pathname]);
};

export default useRouteTracking;
